import React, { Component } from 'react';
import t from 'prop-types';

import OLBing from 'ol/source/bingmaps';

class BingSource extends Component {
  constructor(props) {
    super(props);

    this.bingSource = new OLBing({
      key: props.apiKey,
      imagerySet: props.imagerySet,
      maxZoom: props.maxZoom
    })

    props.tileLayer.setSource(this.bingSource);
  }

  componentWillUnmount() {
    this.props.tileLayer.setSource(null);
  }

  render() {
    return null
  }
}

BingSource.propTypes = {
  apiKey: t.string.isRequired,
  imagerySet: t.string.isRequired,
  maxZoom: t.number
}

export default BingSource;



// WEBPACK FOOTER //
// ./src/components/ol/BingSource.js